<template>
  <div id="devicePosition" style="width:100vw; height: 91vh">
    <el-container v-loading="loading" style="height: 91vh;" element-loading-text="拼命加载中">
      <el-aside width="400px" style="background-color: #ffffff">
        <DeviceTree :clickEvent="clickEvent" :contextMenuEvent="contextMenuEvent"></DeviceTree>
      </el-aside>
      <el-container>
        <el-header height="5vh"
          style="font-size: 17px;line-height:5vh; display: grid; grid-template-columns: 20% 30% 45% 4%">
          <div style="text-align: left">
            分屏:
            <i class="iconfont icon-a-mti-1fenpingshi btn" :class="{active:spiltIndex === 0}" @click="spiltIndex=0" />
            <i class="iconfont icon-a-mti-4fenpingshi btn" :class="{active: spiltIndex === 1}" @click="spiltIndex=1" />
            <i class="iconfont icon-a-mti-6fenpingshi btn" :class="{active: spiltIndex === 2}" @click="spiltIndex=2" />
            <i class="iconfont icon-a-mti-9fenpingshi btn" :class="{active: spiltIndex === 3}" @click="spiltIndex=3" />
          </div>
          <div style="text-align: left">
            <el-autocomplete size="small" class="inline-input" v-model="currentName" :fetch-suggestions="querySearch"
              placeholder="请输入配置名称" clearable @select="handleSelect" @clear="clearConfig">
              <template slot-scope="{ item }">
                <div class="name">{{ item.name }}</div>
              </template>
            </el-autocomplete>
            <el-button-group>
              <el-tooltip v-if="!this.currentId" class="item" effect="light" content="保存当前配置" placement="top">
                <el-button type="primary" icon="el-icon-plus" size="mini" @click="addConfig"></el-button>
              </el-tooltip>
              <el-tooltip v-if="!!this.currentId" class="item" effect="light" content="修改当前配置" placement="top">
                <el-button type="primary" icon="el-icon-edit" size="mini" @click="updateConfig"></el-button>
              </el-tooltip>
              <el-tooltip v-if="!!this.currentId" class="item" effect="light" content="删除当前配置" placement="top">
                <el-button type="primary" icon="el-icon-delete" size="mini" @click="delConfig"></el-button>
              </el-tooltip>
            </el-button-group>
          </div>
          <div style="text-align: right">
            <span>轮播间隔时间(秒):</span>
            <el-input-number v-model="intervalTime" controls-position="right" size="mini" :min="1" :max="1000"
              @change="changeTime"></el-input-number>
            <el-button v-if="looper==''" type="warning" size="mini" @click="lbShow">启动轮播查看</el-button>
            <el-button v-else type="danger" size="mini" @click="lbStop">停止轮播查看</el-button>
          </div>
          <div style="text-align: right">
            <el-tooltip class="item" effect="light" content="全屏" placement="top">
              <i class="el-icon-full-screen btn" @click="fullScreen()" />
            </el-tooltip>
          </div>
        </el-header>
        <el-main style="padding: 0; margin: 0 auto; background-color: #a9a8a8">
          <div ref="playBox" :style="{width: '151vh', height: '85vh', display: 'grid', gridTemplateColumns: layout[spiltIndex].columns,
           gridTemplateRows: layout[spiltIndex].rows, gap: '4px', backgroundColor: '#a9a8a8'}">
            <div v-for="i in layout[spiltIndex].spilt" :key="i" class="play-box" :class="getPlayerClass(spiltIndex, i)"
              @click="playerIdx = (i-1)">
              <div v-show="!videoUrl[i-1]" style="color: #ffffff;font-size: 15px;font-weight: bold;">
                {{videoTip[i-1]?videoTip[i-1]:"无信号"}}
              </div>
<!--             <player :ref="'player'+(i-1)" v-else :isRefresh="isRefresh" :videoUrl="videoUrl[i-1]" fluent autoplay @screenshot="shot"
                @destroy="destroy" /> -->
              <rtc-player  :ref="'player'+(i-1)" v-show="videoUrl[i-1]" :error="videoError" :message="videoError" height="100px"
                             fluent autoplay live></rtc-player>


              <!--             <h265web2 :ref="'player'[i-1]" v-else :videoUrl="videoUrl[i-1]" fluent autoplay @screenshot="shot"
                @destroy="destroy" ></h265web2> -->
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
  import uiHeader from "../layout/UiHeader.vue";
  import player from './common/jessibuca.vue'
  // import h265web2 from './common/h265web2.vue'
  import rtcPlayer from './common/rtcPlayer.vue'

  import DeviceTree from './common/DeviceTree.vue'
  import screenfull from "screenfull";

  import ConfigService from "./service/ConfigService.js";

  export default {
    name: "live",
    components: {
      uiHeader,
      player,
      DeviceTree,
      // h265web2
      rtcPlayer
    },

    data() {
      return {
        videoUrl: [],
        videoTip: [],
        spiltIndex: 3, //分屏
        playerIdx: 0, //激活播放器
        looper: "", //轮播定时器id
        looperIdx: 0, //轮播当前第几个配置

        //channel
        loading: false,
        layout: [{
            spilt: 1,
            columns: "1fr",
            rows: "1fr",
            style: function() {}
          },
          {
            spilt: 4,
            columns: "1fr 1fr",
            rows: "1fr 1fr",
            style: function() {}
          },
          {
            spilt: 6,
            columns: "1fr 1fr 1fr",
            rows: "1fr 1fr 1fr",
            style: function(index) {
              // console.log(index)
              if (index === 0) {
                return {
                  gridColumn: ' 1 / span 2',
                  gridRow: ' 1 / span 2',
                }
              }
            }

          },
          {
            spilt: 9,
            columns: "repeat(3, minmax(100px, 1fr))",
            rows: "repeat(3, minmax(100px, 1fr))",
            style: function() {}
          },
        ],
        configList: [],
        currentName: '',
        currentId: "",
        currentData: "",
        configService: new ConfigService(),
        intervalTime: 7,
        refreshTimeId:null,
        isRefresh:false,
      };
    },
    mounted() {
      this.loadAll();
      this.intervalTime = localStorage.getItem("jgTime") || 7

    },
    created() {
      this.checkPlayByParam()
    },
    computed: {

    },
    watch: {
      '$route.fullPath': 'checkPlayByParam'
    },
    destroyed() {
      if (this.looper) clearInterval(this.looper);
    },
    methods: {
      videoError: function (e) {
        console.log("播放器错误：" + JSON.stringify(e));
      },
      changeTime(e) {
        // console.log(e);
        localStorage.setItem("jgTime", e);
        if (this.looper) {
          clearInterval(this.looper);
          this.looper = "";
          this.lbShow();
        }
      },
      lbShow() {
        if (this.configList.length <= 0) {
          this.$message.warning("暂无配置，无法启动轮播。请先去保存一些后再试。");
        }
        let lastCall = Date.now();
        this.handleSelect(this.configList[this.looperIdx]);
        if(this.refreshTimeId){
          clearInterval(this.refreshTimeId);
          this.refreshTimeId=null;
        }
        this.looper = setInterval(() => {
          if (this.looperIdx >= this.configList.length-1) {
            this.looperIdx = 0;
          } else {
            this.looperIdx++;
          }
          this.handleSelect(this.configList[this.looperIdx]);

          let now = Date.now();

          // 由最后一次调用时间和当前时间计算出间隔时间
          let delay = now - lastCall;
          lastCall = now;
          console.log("interval---", delay);

        }, this.intervalTime * 1000)
      },
      lbStop() {
        if (this.looper) {
          clearInterval(this.looper);
          this.looper = "";
          this.startRefreshTime();
          // this.looperIdx = 0;
          // this.clearConfig();
        }

      },
      startRefreshTime(){
        if(this.refreshTimeId){
          clearInterval(this.refreshTimeId);
          this.refreshTimeId = null;
        }
        if(this.looper==""||this.looper==null){
          this.refreshTimeId = setInterval(() => {
            // this.destroy();
            // let lsUrl=JSON.stringify(this.videoUrl)
            // this.videoUrl=[];
            // setTimeout(()=>{
            //  this.videoUrl=JSON.parse(lsUrl);
            // },300)
            // console.log(this.videoUrl);

           for (var index = 0; index < this.layout[this.spiltIndex].spilt; index++) {
             if(this.videoUrl[index]){
             this.$set(this.videoTip, index, "正在拉流...")
             this.$refs['player' + index][0].play(this.videoUrl[index],index)
             }else{
               this.$set(this.videoTip, index, "")
               this.$refs['player' + index][0].play(null,index)
             }
           }

          }, 30*60* 1000)
        }
      },

      addConfig() {
        if (this.currentName == null || this.currentName == "") {
          this.$message.warning("请输入配置名称");
          return false
        }
        this.configService.addServer({
          name: this.currentName,
          videoUrlStr: JSON.stringify(this.videoUrl),
          spilt: this.spiltIndex
        }, (data) => {

          if (data.code == 0) {
            this.$message.success("配置保存成功");
            this.loadAll(this.currentName);
          } else {
            this.$message.error("配置保存失败");
          }

        })
      },
      updateConfig() {
        if (this.currentId == null || this.currentId == "") {
          this.$message.warning("请先选择一个配置");
          return false
        }
        this.configService.editServer({
          idstr: this.currentId,
          name: this.currentName,
          videoUrlStr: JSON.stringify(this.videoUrl),
          spilt: this.spiltIndex
        }, (data) => {
          if (data.code == 0) {
            this.$message.success("配置保存成功");
          } else {
            this.$message.error("配置保存失败");
          }
        })
      },
      delConfig() {
        if (this.currentId == null || this.currentId == "") {
          this.$message.warning("请先选择一个配置");
          return false
        }
        this.$confirm('确定将配置名：' + this.currentName + ' 删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.configService.delete(this.currentId, (data) => {
            if (data.code == 0) {
              this.$message.success("配置已删除");
              this.loadAll();
              this.clearConfig();
            } else {
              this.$message.error("配置删除失败");
            }
          })
        }).catch(() => {

        });

      },

      querySearch(queryString, cb) {
        var configList = this.configList;
        // var results = queryString ? configList.filter(this.createFilter(queryString)) : configList;
        // 调用 callback 返回建议列表的数据
        cb(configList);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      loadAll(name = "") {
        this.configService.getConfigServiceList({}, (data) => {
          this.configList = data.data || [];
          // console.log(">>>>",data.data);
          this.configList.forEach(item => {
            if (item.name == name) {
              this.handleSelect(item);

            }
          })

        })
      },
      handleSelect(item) {
        console.log(item);
        // this.destroy();
        this.currentId = item.idstr;
        this.currentData = item;
        this.currentName = item.name;
        this.spiltIndex = item.spilt || 3; //分屏
        this.playerIdx = 0; //激活播放器
        this.videoUrl = item.videoUrlStr ? JSON.parse(item.videoUrlStr) : [];
        for (var index = 0; index < this.layout[this.spiltIndex].spilt; index++) {
          if(this.videoUrl[index]){
          this.$set(this.videoTip, index, "正在拉流...")
          this.$refs['player' + index][0].play(this.videoUrl[index],index)
          }else{
            this.$set(this.videoTip, index, "")
            this.$refs['player' + index][0].play(null,index)
          }
        }
        this.startRefreshTime();
      },
      clearConfig() {
        this.currentId = "";
        this.currentData = {};
        this.currentName = "";
        this.videoUrl = [];
        this.videoTip = [];
        this.spiltIndex = 3; //分屏
        this.playerIdx = 0; //激活播放器
      },
      clickEvent: function(channelId) {
        this.sendDevicePush(channelId)
      },
      getPlayerClass: function(splitIndex, i) {
        let classStr = "play-box-" + splitIndex + "-" + i
        if (this.playerIdx === (i - 1)) {
          classStr += " redborder"
        }
        return classStr
      },
      contextMenuEvent: function(device, event, data, isCatalog) {

      },
      //通知设备上传媒体流
      sendDevicePush: function(channelId) {
        // this.save(channelId)
        let idxTmp = this.playerIdx
        this.setPlayUrl("", idxTmp);
        this.$set(this.videoTip, idxTmp, "正在拉流...")
        this.$axios({
          method: 'get',
          url: '/api/common/channel/play',
          params: {
            channelId: channelId
          }
        }).then((res) => {
          if (res.data.code === 0 && res.data.data) {
            let videoUrl;
            if (location.protocol === "https:") {
              videoUrl = res.data.data.rtcs;
            } else {
              videoUrl = res.data.data.rtc;
            }
            // if (location.protocol === "https:") {
            //   videoUrl = res.data.data.wss_flv;
            // } else {
            //   videoUrl = res.data.data.ws_flv;
            // }
            this.setPlayUrl(videoUrl, idxTmp);
          } else {
            this.$set(this.videoTip, idxTmp, "播放失败: " + res.data.msg)
          }
        }).catch(function(e) {}).finally(() => {
          this.loading = false
        });
      },
      setPlayUrl(url, idx) {
        this.$set(this.videoUrl, idx, url)
        this.$refs['player' + idx][0].play(url,idx);
        this.startRefreshTime();
        console.log(this.videoUrl,url,idx);

      },
      checkPlayByParam() {
        let query = this.$route.query
        if (query.channelId) {
          this.sendDevicePush(query.channelId)
        }
      },
      shot(e) {
        // console.log(e)
        // send({code:'image',data:e})
        var base64ToBlob = function(code) {
          let parts = code.split(';base64,');
          let contentType = parts[0].split(':')[1];
          let raw = window.atob(parts[1]);
          let rawLength = raw.length;
          let uInt8Array = new Uint8Array(rawLength);
          for (let i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
          }
          return new Blob([uInt8Array], {
            type: contentType
          });
        };
        let aLink = document.createElement('a');
        let blob = base64ToBlob(e); //new Blob([content]);
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
        aLink.download = '截图';
        aLink.href = URL.createObjectURL(blob);
        aLink.click();
      },
      save(item) {
        let dataStr = window.localStorage.getItem('playData') || '[]'
        let data = JSON.parse(dataStr);
        data[this.playerIdx] = item
        window.localStorage.setItem('playData', JSON.stringify(data))
      },
      clear(idx) {
        let dataStr = window.localStorage.getItem('playData') || '[]'
        let data = JSON.parse(dataStr);
        data[idx - 1] = null;
        // console.log(data);
        window.localStorage.setItem('playData', JSON.stringify(data))
      },
      fullScreen: function() {
        if (screenfull.isEnabled) {
          screenfull.toggle(this.$refs.playBox);
        }
      },
    async  destroy() {
        console.log("##>>",this._webrtcPlayers);
        if(this._webrtcPlayers){
          for (const key in this._webrtcPlayers) {
              if (this._webrtcPlayers.hasOwnProperty(key) && this._webrtcPlayers[key]!=null) {
                 await this._webrtcPlayers[key].off();
                 await this._webrtcPlayers[key].close();
                 // delete  this._webrtcPlayers[key];
                 this._webrtcPlayers[key]=null;
              }
          }
        }
      },
      // async  destroy() {
      //     console.log("##>>",window.jessibucaPlayer);

      //     if(window.jessibucaPlayer){
      //       for (const key in window.jessibucaPlayer) {
      //           if (window.jessibucaPlayer.hasOwnProperty(key) && window.jessibucaPlayer[key]!=null) {
      //              await window.jessibucaPlayer[key].off();
      //              await window.jessibucaPlayer[key].destroy();
      //              delete  window.jessibucaPlayer[key];
      //           }

      //       }

      //     }


      //   },
    }
  };
</script>
<style>
  .btn {
    margin: 0 10px;
    cursor: pointer;

  }

  .btn:hover {
    color: #409EFF;
  }

  .btn.active {
    color: #409EFF;


  }

  .redborder {
    border: 4px solid rgb(0, 198, 255) !important;
  }

  .play-box {
    background-color: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .play-box-2-1 {
    grid-column: 1 / span 2;
    grid-row: 1 / span 2;
  }
</style>
<style>
  .videoList {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
  }

  .video-item {
    position: relative;
    width: 15rem;
    height: 10rem;
    margin-right: 1rem;
    background-color: #000000;
  }

  .video-item-img {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    height: 100%;
  }

  .video-item-img:after {
    content: "";
    display: inline-block;
    position: absolute;
    z-index: 2;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 3rem;
    height: 3rem;
    background-image: url("../assets/loading.png");
    background-size: cover;
    background-color: #000000;
  }

  .video-item-title {
    position: absolute;
    bottom: 0;
    color: #000000;
    background-color: #ffffff;
    line-height: 1.5rem;
    padding: 0.3rem;
    width: 14.4rem;
  }

  .baidumap {
    width: 100%;
    height: 100%;
    border: none;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 去除百度地图版权那行字 和 百度logo */
  .baidumap>.BMap_cpyCtrl {
    display: none !important;
  }

  .baidumap>.anchorBL {
    display: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/live.vue